function useSendMessage(src) {
   const sendMessagePopUp = (message, newSrc) => {
      const finalSrc = newSrc || src;
      if (window.opener) {
         window.opener.postMessage({status: 'ok', message}, finalSrc);
      }
   };

   const sendMessageIFrame = (message, newSrc) => {
      const finalSrc = newSrc || src;
      if (window.parent) {
         window.parent.postMessage({status: 'ok', message}, finalSrc);
      }
   };

   return {sendMessageIFrame, sendMessagePopUp};
}

export default useSendMessage;
